import { CENTRAL_DOACOES_PERMISSIONS } from "constants/index";
import React, { Component } from "react";
import { connect } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import WidgetDialog from "../../../components/Dialog/dialog.component";
import Title from "../../../components/Title/title.component";
import centralDoacaoService from "../../../services/centralDoacaoService";
import municipioService from "../../../services/municipioService";
import { validatePermission } from "../../../utils/permissionHelper";
import ToastHelper from "../../../utils/toastHelper";
import ListagemContainer, {
	PesquisaAvancadaContext
} from "../../comum/containers/listagem.container";
import CadastraOficio from "../cadastraOficio/cadastraOficio.modal";
import CancelarModalOficio from "../cancelarOficio/cancelarOficio.modal";
import EditaOficio from "../editaOficio/editaOficio.modal";
import VisualizaOficio from "../visualizaOficio/visualizaOficio.modal";
import PesquisaAvancadaOficio from "./pesquisaAvancadaOficio";

const mapStateToProps = state => ({ usuario: state.auth.usuario });

class ListaOficios extends Component {
	state = {
		isOpenVisualizar: false,
		oficioSelecionado: { ...{} },
		isOpenCancelarOficio: false,
		oficio: { ...{} },
		isOpenDialogNaoPodeCancelar: false,
		isOpenEditar: false,
		pesquisaAvancada: false,
		municipios: [],
		statusOficio: [],
		orderIcon: {
			nome: "",
			icon: undefined
		},
		inititalOrderIcon: {
			colunaTable: "entidade.nome",
			iconOrderDirection: "fas fa-arrow-up"
		}
	};

	columns = [
		{
			id: 0,
			title: "Município",
			property: "nomeMunicio",
			order: "LIST_ORDER_MUNICIPIO"
		},
		{
			id: 1,
			title: "Entidade",
			property: "nomeEntidade",
			order: "entidade.nome"
		},
		{
			id: 2,
			title: "Data de recebimento",
			property: "dataRecebimento",
			order: "dataRecebimento"
		},
		{
			id: 3,
			title: "Status",
			property: "status",
			order: "status.codigo"
		}
	];

	/*
		** ATENÇÃO **

		NÃO ALTERAR A ORDEM DAS ACTIONS
		NÃO ALTERAR A ORDEM DAS ACTIONS
		NÃO ALTERAR A ORDEM DAS ACTIONS

		CASO SEJA EXTREMAMENTE NECESSÁRIO ALTERAR, FAÇA O SEGUINTE:
			- NÃO ALTERE

		CASO MESMO ASSIM QUERIA MUDAR, FAÇA ISSO:
			- MUDE A ORDEM ABAIXO
			- VÁ ATÉ O COMPONENTE DE:
				- LISTAGEM CONTAINER
			- PROCURE A FUNÇÃO checkActions, ESTÁ PERTO DO RENDER
			- ALTERE O RETORN DAS ACTIONS PARA A POSIÇÃO ATUAL DA ACTION VISUALIZAR
			- LEMBRANDO QUE ARRAY COMEÇA EM 0
	*/

	/* Inicializando componente */

	async componentDidMount() {
		const responseMunicipio = await municipioService.findAll();
		const responseStatusOficio = await centralDoacaoService.findAllStatusOficio();
		this.setState({
			municipios: [...responseMunicipio.data],
			statusOficio: [...responseStatusOficio.data]
		});
	}

	showGerenciar() {
		const { usuario } = this.props;
		return validatePermission(
			CENTRAL_DOACOES_PERMISSIONS.GERENCIAR_OFICIO,
			usuario.soeAcoes
		);
	}

	get actions() {
		return [
			{
				id: 0,
				name: "Visualizar",
				icon: "fas fa-search",
				action: item => this.handleVisualizar(item)
			},
			{
				id: 1,
				name: "Editar",
				icon: "fas fa-edit",
				action: item => this.handleEditar(item),
				enabled: item => !item.cancelado,
				checkRule: true,
				show: this.showGerenciar.bind(this)
			},
			{
				id: 2,
				name: "Cancelar",
				icon: "fas fa-times",
				action: item => this.handleBuscarOficioCancelar(item),
				enabled: item => !item.cancelado,
				checkRule: true,
				show: this.showGerenciar.bind(this)
			}
		];
	}

	/* Modal visualizar ofício */

	handleOpenVisualizarOficio = () => {
		this.setState({ isOpenVisualizar: true });
	};

	handleCloseVisualizar = () => {
		this.setState({ isOpenVisualizar: false });
	};

	async handleVisualizar(item) {
		try {
			const response = await centralDoacaoService.findOficioById(item.id);
			this.setState({ oficioSelecionado: response.data });
			this.handleOpenVisualizarOficio();
		} catch (error) {
			ToastHelper.warn(error.response.data.message);
		}
	}

	createModalVisualizar = item =>
		this.state.isOpenVisualizar && (
			<VisualizaOficio
				isOpenVisualizar={this.state.isOpenVisualizar}
				handleCloseVisualizar={this.handleCloseVisualizar}
				oficio={this.state.oficioSelecionado}
			/>
		);

	/* Modal editar ofício */

	createModalEditarOficio = () =>
		this.state.isOpenEditar && (
			<EditaOficio
				isOpenEditar={this.state.isOpenEditar}
				handleCloseEditar={this.handleCloseEditar}
				handleSubmitEditar={this.handleSubmitEditar}
				oficioProp={this.state.oficioSelecionado}
			/>
		);

	async handleEditar(item) {
		try {
			const response = await centralDoacaoService.findOficioById(item.id);
			this.setState({ oficioSelecionado: response.data });
			this.handleOpenEditar();
		} catch (error) {
			ToastHelper.warn(error);
		}
	}

	handleOpenEditar = () => {
		this.setState({ isOpenEditar: true });
	};

	handleCloseEditar = () => {
		this.setState({ isOpenEditar: false });
	};

	handleSubmitEditar = async values => {
		try {
			await centralDoacaoService.editarOficio(values);
			ToastHelper.success("Edição concluída com sucesso.");
			this.handleCloseEditar();
			this.handleReload();
		} catch (error) {
			ToastHelper.warn(error.response.data.message);
		}
	};

	/*
		MODAL CANCELAR OFICIO
	*/

	handleCancelarOficio = () => {
		this.setState({ isOpenCancelarOficio: true });
	};

	handleOpenDialogNaoPodeCancelar = () => {
		this.setState({ isOpenDialogNaoPodeCancelar: true });
	};

	async handleBuscarOficioCancelar(item) {
		// O serviço de busca do objeto oficio retorna a variavel porSerCancelado, depedendo do resultado o comportamento muda.
		try {
			const response = await centralDoacaoService.findOficioById(item.id);
			this.setState({ oficio: response.data });
			this.state.oficio.podeSerCancelado
				? this.handleCancelarOficio()
				: this.handleOpenDialogNaoPodeCancelar();
		} catch (error) {
			ToastHelper.warn(error.response.data.message);
		}
	}

	/*
		Handler para pesquisa simplificada e avançada
	*/

	handlePesquisaSimplificada = () => {
		const prevState = this.state;
		prevState.pesquisaAvancada = false;
		prevState.orderIcon = { icon: undefined, nomeColuna: "" };
		this.setState(prevState);
		this.child.current.limpaCampoPesquisaSimplificada();
	};

	handlePesquisaAvancada = () => {
		const prevState = this.state;
		prevState.pesquisaAvancada = true;
		prevState.orderIcon = { icon: undefined, nomeColuna: "" };
		this.setState(prevState);
	};

	createCancelarModalOficio = () =>
		this.state.oficio && (
			<CancelarModalOficio
				podeSerCancelado={this.state.oficio.podeSerCancelado}
				isOpenCancelarOficio={this.state.isOpenCancelarOficio}
				handleCloseCancelar={() =>
					this.setState(prevState => ({
						prevState,
						isOpenCancelarOficio: false
					}))
				}
				handleSubmitCancelar={async () => {
					await centralDoacaoService.cancelarOficio(
						this.state.oficio
					);
					ToastHelper.success("Ofício cancelado com sucesso.");
					this.setState(prevState => ({
						prevState,
						isOpenCancelarOficio: false
					}));
					this.handleReload();
				}}
			/>
		);

	constructor(props) {
		super(props);
		this.child = React.createRef();
	}

	resetIconOrder = () => {
		this.setState({ orderIcon: { icon: undefined, nomeColuna: "" } });
	};

	handleReload() {
		this.child.current.initialize();
	}

	ordenar = ordem => {
		const direcaoOrdemFiltro = this.child.current.handleSearchByOrder(
			ordem,
			false
		);

		if (direcaoOrdemFiltro === "DESC") {
			this.setState({
				orderIcon: { icon: "fas fa-arrow-down", nomeColuna: ordem }
			});
		} else {
			this.setState({
				orderIcon: { icon: "fas fa-arrow-up", nomeColuna: ordem }
			});
		}
	};

	handleDialogNaoPodeCancelar = () => (
		<WidgetDialog
			title="Atenção!"
			isOpen={this.state.isOpenDialogNaoPodeCancelar}
			textConfirmar="Ok"
			mensagem="Não é possível cancelar este ofício pois está vinculado a uma transação de saída."
			confirmar={() => {
				this.setState({ isOpenDialogNaoPodeCancelar: false });
			}}
		/>
	);

	render() {
		const {
			filtro,
			municipios,
			pesquisaAvancada,
			statusOficio,
			orderIcon,
			inititalOrderIcon
		} = this.state;
		return (
			<React.Fragment>
				<div className="row">
					<div className="col-md-12">
						<Title>Ofícios</Title>
					</div>
				</div>
				<ListagemContainer
					ref={this.child}
					columns={this.columns}
					actions={this.actions}
					titleButtonCadastrar="Cadastrar ofício"
					listaTitle="Listagem de ofícios"
					pesquisaTitle={null}
					servicePaginacao={centralDoacaoService.findAllOficios}
					serviceSearch={centralDoacaoService.findAllOficios}
					serviceCadastrar={centralDoacaoService.salvarOficio}
					acoesSingleButton={false}
					emptyMessage="Não há ofícios cadastrados."
					ComponenteCadastrar={CadastraOficio}
					searchPlaceHolder="Pesquise por município"
					toastMessage="Ofício cadastrado com sucesso"
					trClass={item => (item.cancelado ? "cancelado" : "")}
					pesquisaAvancada={pesquisaAvancada}
					isPesquisaAvancada
					handlePesquisaAvancada={this.handlePesquisaAvancada}
					ordenar={this.ordenar}
					isOrderByGrid
					orderIcon={orderIcon}
					inititalOrderIcon={inititalOrderIcon}
					oficio
					permission={CENTRAL_DOACOES_PERMISSIONS.VISUALIZAR}
					permissionCadastrar={
						CENTRAL_DOACOES_PERMISSIONS.GERENCIAR_OFICIO
					}
				>
					<PesquisaAvancadaContext.Consumer>
						{() => (
							<PesquisaAvancadaOficio
								filtro={filtro}
								municipios={municipios}
								statusOficio={statusOficio}
								handlePesquisaSimplificada={
									this.handlePesquisaSimplificada
								}
								serviceSearch={values => {
									this.setState({
										pesquisaAvancada: { ...values }
									});
									this.child.current.manualSearch(
										centralDoacaoService.findAllOficios,
										values
									);
								}}
								resetIconOrder={this.resetIconOrder}
							/>
						)}
					</PesquisaAvancadaContext.Consumer>
				</ListagemContainer>
				{this.createModalVisualizar()}
				{this.createCancelarModalOficio()}
				{this.handleDialogNaoPodeCancelar()}
				{this.createModalEditarOficio()}
			</React.Fragment>
		);
	}
}

export default connect(mapStateToProps)(ListaOficios);
